export const readingExtractedMessages = {
  "reading.JournalAttachments.title": "Private attachments",
  "reading.JournalAttachments.help":
    "Up to five PNG, JPEG, GIF, WebP, or PDF files, 10 MiB each. Attachments stay private with this entry.",
  "reading.JournalAttachments.files": "Attached files",
  "reading.JournalAttachments.download": "Download",
  "reading.JournalAttachments.remove": "Remove",
  "reading.JournalAttachments.file": "File",
  "reading.JournalAttachments.description": "Accessible description",
  "reading.JournalAttachments.uploading": "Uploading…",
  "reading.JournalAttachments.add": "Add attachment",
  "reading.ReflectionPrompt.optionalPrivate": "Optional private reflection",
  "reading.ReflectionPrompt.privacyHelp":
    "Only you can see this answer. Skipping has no effect on goals, streaks, or recommendations.",
  "reading.ReflectionPrompt.write": "Write a reflection",
  "reading.ReflectionPrompt.skip": "Skip this prompt",
  "reading.ReflectionPrompt.before": "What are you hoping to find in this book?",
  "reading.ReflectionPrompt.during": "What are you noticing or wondering so far?",
  "reading.ReflectionPrompt.complete": "What will stay with you from this book?",
  "reading.ReflectionPrompt.dnf": "What made this the right place to stop?",
  "reading.ReflectionPrompt.showHistory": "Show edit history",
  "reading.ReflectionPrompt.hideHistory": "Hide edit history",
  "reading.ReflectionPrompt.loadingHistory": "Loading edit history…",
  "reading.ReflectionPrompt.noHistory": "No earlier versions.",
  "reading.ContinueReadingCard.continueReading": "Continue reading",
  "reading.ContinueReadingCard.currentPage": "Page {page}",
  "reading.ContinueReadingCard.logProgress": "Log progress",
  "reading.ContinueReadingCard.pageCount": "Page {page} of {pages}",
  "reading.ContinueReadingCard.progressLabel":
    "{title} reading progress: {percentage}%",
  "reading.ContinueReadingCard.viewBook": "View book",
  "reading.JournalEntryDialog.book": "Book",
  "reading.JournalEntryDialog.cancel": "Cancel",
  "reading.JournalEntryDialog.content": "Content",
  "reading.JournalEntryDialog.dateAndTime": "Date and time",
  "reading.JournalEntryDialog.endingPage": "Ending page",
  "reading.JournalEntryDialog.entryType": "Entry type",
  "reading.JournalEntryDialog.generalReading": "General reading",
  "reading.JournalEntryDialog.keepAPrivateThoughtPassageOrHighlight":
    "Keep a private thought, passage, or highlight connected to your reading.",
  "reading.JournalEntryDialog.startingPage": "Starting page",
  "reading.JournalEntryDialog.sourceAttribution": "Source attribution",
  "reading.JournalEntryDialog.attributionHelp":
    "Source identity is captured when you save and remains unchanged if you switch editions later.",
  "reading.JournalEntryDialog.translator": "Translator (if known)",
  "reading.JournalEntryDialog.edition": "Edition details",
  "reading.JournalEntryDialog.component": "Contained work or volume",
  "reading.JournalEntryDialog.location": "Location or chapter",
  "reading.JournalEntryDialog.timestampStart": "Start time (seconds)",
  "reading.JournalEntryDialog.timestampEnd": "End time (seconds)",
  "reading.JournalEntryDialog.sourceNotes": "Private source notes",
  "reading.MarkdownEditor.bold": "Bold",
  "reading.MarkdownEditor.boldText": "bold text",
  "reading.MarkdownEditor.draftRecovered":
    "Recovered an unsaved draft from this device.",
  "reading.MarkdownEditor.formatting": "Formatting",
  "reading.MarkdownEditor.heading": "Heading",
  "reading.MarkdownEditor.italic": "Italic",
  "reading.MarkdownEditor.italicText": "italic text",
  "reading.MarkdownEditor.link": "Link",
  "reading.MarkdownEditor.linkText": "link text",
  "reading.MarkdownEditor.list": "List",
  "reading.MarkdownEditor.listItem": "list item",
  "reading.MarkdownEditor.markdownHelp": "Markdown preview. Raw HTML is not supported.",
  "reading.MarkdownEditor.opensInNewTab": "(opens in a new tab)",
  "reading.MarkdownEditor.preview": "Preview",
  "reading.MarkdownEditor.quotation": "quotation",
  "reading.MarkdownEditor.quote": "Quote",
  "reading.JournalEntryDialog.organization": "Highlight organization",
  "reading.JournalEntryDialog.label": "Label",
  "reading.JournalEntryDialog.color": "Color",
  "reading.JournalEntryDialog.noColor": "No color",
  "reading.JournalEntryDialog.favorite": "Favorite highlight",
  "reading.JournalEntryDialog.tags": "Tags",
  "reading.JournalEntryDialog.spoilerControls": "Spoiler controls",
  "reading.JournalEntryDialog.containsSpoilers": "Contains spoilers",
  "reading.JournalEntryDialog.revealAfterPercent": "Reveal after reading (%)",
  "reading.JournalEntryDialog.revealAfterCompletion": "Reveal after completion",
  "reading.JournalEntryDialog.spoilerHidden": "Spoiler hidden",
  "reading.JournalEntryDialog.revealSpoiler": "Reveal spoiler",
  "reading.ReadingPage.allColors": "All colors",
  "reading.ReadingPage.allBooks": "All books",
  "reading.ReadingPage.author": "Author",
  "reading.ReadingPage.filterByAuthor": "Filter by author",
  "reading.ReadingPage.filterByBook": "Filter by book",
  "reading.ReadingPage.journalPages": "Journal result pages",
  "reading.ReadingPage.nextPage": "Next page",
  "reading.ReadingPage.previousPage": "Previous page",
  "reading.ReadingPage.highlightColor": "Highlight color",
  "reading.ReadingPage.bulkHighlightOrganization": "Bulk highlight organization",
  "reading.ReadingPage.bulkColor": "Color for selected highlights",
  "reading.ReadingPage.bulkTag": "Tag for selected highlights",
  "reading.ReadingPage.keepColor": "Keep current colors",
  "reading.ReadingPage.keepTags": "Keep current tags",
  "reading.ReadingPage.applyOrganization": "Apply organization",
  "reading.ReadingPage.tryDifferentHighlightFilters":
    "Try a different search or highlight filter.",
  "reading.ReadingPage.captureFirstJournalEntry":
    "Capture a thought, quotation, highlight, or reflection as you read.",
  "reading.ReadingPage.noEntriesMatch": "No entries match",
  "reading.ReadingPage.yourJournalIsReady": "Your journal is ready",
  "reading.ReadingPage.favoriteSelected": "Favorite selected",
  "reading.ReadingPage.favoritesOnly": "Favorites only",
  "reading.ReadingPage.clearSelection": "Clear selection",
  "reading.ReadingPage.selectHighlight": "Select highlight",
  "reading.ReadingPage.selectedHighlights": "{count} selected",
  "reading.ReadingPage.sortEntries": "Sort journal entries",
  "reading.ReadingPage.newestFirst": "Newest first",
  "reading.ReadingPage.oldestFirst": "Oldest first",
  "reading.ReadingPage.recentlyUpdated": "Recently updated",
  "reading.ReadingPage.sortByLabel": "Label",
  "reading.ProgressDialog.cancel": "Cancel",
  "reading.ProgressDialog.addDetails": "Add time or note (optional)",
  "reading.ProgressDialog.hideDetails": "Hide time and note",
  "reading.ProgressDialog.endedAt": "Ended at",
  "reading.ProgressDialog.endingPage": "Ending page",
  "reading.ProgressDialog.endingElapsed": "Elapsed audiobook time (H:MM:SS)",
  "reading.ProgressDialog.elapsedHelp": "Current and total listening time:",
  "reading.ProgressDialog.logProgress": "Log progress",
  "reading.ProgressDialog.notes": "Notes",
  "reading.ProgressDialog.optional": "(optional)",
  "reading.ProgressDialog.progressSaved":
    "Progress saved at page {page}: {pages, plural, one {# page read} other {# pages read}}.",
  "reading.ProgressDialog.quickPageChanges": "Quick page changes",
  "reading.ProgressDialog.quickSessionTime": "Quick session time",
  "reading.ProgressDialog.minutesAgo": "Last {minutes} min",
  "reading.ProgressDialog.yesterdayThirtyMinutes": "Yesterday · 30 min",
  "reading.ProgressDialog.startedAt": "Started at",
  "reading.ProgressDialog.startingFromPage": "Starting from page",
  "reading.ReadingPage.activeDays": "Active days",
  "reading.ReadingPage.allBookTags": "All book tags",
  "reading.ReadingPage.allEntryTypes": "All entry types",
  "reading.ReadingPage.allTime": "All time",
  "reading.ReadingPage.aRecordOfTheTimePagesAnd":
    "A record of the time, pages, and thoughts that shaped your reading.",
  "reading.ReadingPage.deleteJournalEntry": "Delete journal entry",
  "reading.ReadingPage.deleteSession": "Delete reading session",
  "reading.ReadingPage.deleteSessionConfirm":
    "This removes the session and recalculates this book's progress and later sessions.",
  "reading.ReadingPage.deleteSessionTitle": "Delete reading session?",
  "reading.ReadingPage.sessionWillBeDeleted": "Reading session deleted.",
  "reading.ReadingPage.editJournalEntry": "Edit journal entry",
  "reading.ReadingPage.editSession": "Edit reading session",
  "reading.ReadingPage.sessionActions": "Reading session actions",
  "reading.ReadingPage.repeatSession": "Log a similar session",
  "reading.ReadingPage.entries": "entries.",
  "reading.ReadingPage.filterByBookTag": "Filter by book tag",
  "reading.ReadingPage.filterByEntryType": "Filter by entry type",
  "reading.ReadingPage.filters": "Filters",
  "reading.ReadingPage.activeFilters":
    "{count, plural, one {# active filter} other {# active filters}}",
  "reading.ReadingPage.clearAllFilters": "Clear all",
  "reading.ReadingPage.showResults": "Show results",
  "reading.ReadingPage.generalReading": "General reading",
  "reading.ReadingPage.highlights": "Highlights",
  "reading.ReadingPage.journalDateRange": "Journal date range",
  "reading.ReadingPage.journalSummary": "Journal summary",
  "reading.ReadingPage.last30Days": "Last 30 days",
  "reading.ReadingPage.last7Days": "Last 7 days",
  "reading.ReadingPage.last90Days": "Last 90 days",
  "reading.ReadingPage.loadingJournalEntries": "Loading journal entries",
  "reading.ReadingPage.loadingReadingJournal": "Loading reading journal",
  "reading.ReadingPage.currentlyReading": "Currently reading",
  "reading.ReadingPage.chooseCurrentBook": "Choose your current book",
  "reading.ReadingPage.searchCurrentBooks": "Search current books",
  "reading.ReadingPage.searchByTitleOrAuthor": "Search by title or author",
  "reading.ReadingPage.noCurrentBooksMatch": "No current books match your search.",
  "reading.ReadingPage.startReading": "Start reading",
  "reading.ReadingPage.logProgress": "Log progress",
  "reading.ReadingPage.lastSession": "Last session: {duration} · {pages} pages",
  "reading.ReadingPage.chooseNextRead": "Choose your next read",
  "reading.ReadingPage.chooseNextReadHelp":
    "Add a book and mark it as currently reading to start tracking sessions.",
  "reading.ReadingPage.today": "Today",
  "reading.ReadingPage.history": "History",
  "reading.ReadingPage.journal": "Journal",
  "reading.ReadingPage.logYourFirstSession": "Log your first session",
  "reading.ReadingPage.newEntry": "New entry",
  "reading.ReadingPage.noJournalEntriesInThisRange": "No journal entries in this range",
  "reading.ReadingPage.notes": "Notes",
  "reading.ReadingPage.notesQuotesAndHighlights": "Notes, quotes, and highlights",
  "reading.ReadingPage.of": "of",
  "reading.ReadingPage.pages": "pages",
  "reading.ReadingPage.pagesRead": "Pages read",
  "reading.ReadingPage.privateAndSearchable": "Private and searchable",
  "reading.ReadingPage.quotes": "Quotes",
  "reading.ReadingPage.readingJournal": "Reading journal",
  "reading.ReadingPage.reflections": "Reflections",
  "reading.ReadingPage.searchJournalEntries": "Search journal entries",
  "reading.ReadingPage.searchYourJournal": "Search your journal",
  "reading.ReadingPage.sessions": "Sessions",
  "reading.ReadingPage.sessionSaved": "Reading session saved.",
  "reading.ReadingPage.completedBook": "You finished {title}",
  "reading.ReadingPage.completedBookHelp":
    "Your book has been marked finished. Capture what stayed with you while it is fresh.",
  "reading.ReadingPage.addCompletionReflection": "Add a reflection",
  "reading.ReadingPage.sessionSavedAtPage":
    "Session saved at page {page} · {pages, plural, one {# page read} other {# pages read}}.",
  "reading.ReadingPage.showing": "Showing",
  "reading.ReadingPage.theJournalCouldNotBeLoaded": "The journal could not be loaded",
  "reading.ReadingPage.timeRead": "Time read",
  "reading.ReadingPage.tryAgain": "Try again",
  "reading.ReadingPage.writeAnEntry": "Write an entry",
  "reading.ReadingSessionForm.addReadingSession": "Add Reading Session",
  "reading.ReadingSessionForm.bookOptional": "Book (optional)",
  "reading.ReadingSessionForm.cancel": "Cancel",
  "reading.ReadingSessionForm.howWasYourReadingSession":
    "How was your reading session?",
  "reading.ReadingSessionForm.noSpecificBook": "No specific book",
  "reading.ReadingSessionForm.notes": "Notes",
  "reading.ReadingSessionForm.pagesRead": "Pages Read",
  "reading.SessionDialog.activeMinutes": "Active minutes",
  "reading.SessionDialog.advancedDetails": "Advanced time details",
  "reading.SessionDialog.book": "Book",
  "reading.SessionDialog.cancel": "Cancel",
  "reading.SessionDialog.description":
    "Correct the time, timezone, pages, notes, or book. Later progress is recalculated safely.",
  "reading.SessionDialog.endedAt": "Ended at",
  "reading.SessionDialog.general": "General reading",
  "reading.SessionDialog.invalidTime": "The end must be after the start.",
  "reading.SessionDialog.notes": "Notes",
  "reading.SessionDialog.pagesRead": "Pages read",
  "reading.SessionDialog.save": "Save correction",
  "reading.SessionDialog.startedAt": "Started at",
  "reading.SessionDialog.timezone": "IANA timezone",
  "reading.SessionDialog.title": "Edit reading session",
  "reading.ReadingTimer.title": "Reading timer",
  "reading.GlobalTimer.activeSession": "Active reading session",
  "reading.GlobalTimer.finish": "Finish active reading session",
  "reading.QuickAction.open": "Open quick reading actions",
  "reading.QuickAction.read": "Read",
  "reading.QuickAction.title": "Start or log reading",
  "reading.QuickAction.search": "Search books to read",
  "reading.QuickAction.noBooks":
    "Add a book and mark it as to read or currently reading first.",
  "reading.ReadingTimer.chooseBook": "Choose a book",
  "reading.ReadingTimer.start": "Start timer",
  "reading.ReadingTimer.elapsedTime": "Elapsed reading time",
  "reading.ReadingTimer.running": "Timer running",
  "reading.ReadingTimer.timerRecovered":
    "Recovered your reading timer, started {started}. Resume it, finish the session, or discard it below.",
  "reading.ReadingTimer.staleTimerRecovered":
    "This timer started {started} and may have been left running. Review it before saving or discard it below.",
  "reading.ProgressDialog.possibleDuplicate": "Possible duplicate session",
  "reading.ProgressDialog.possibleDuplicateHelp":
    "A session for this book already overlaps this time. Review the times, or save again to keep both sessions.",
  "reading.ProgressDialog.saveAnyway": "Save anyway",
  "reading.ReadingTimer.paused": "Timer paused",
  "reading.ReadingTimer.pause": "Pause",
  "reading.ReadingTimer.resume": "Resume",
  "reading.ReadingTimer.finish": "Finish",
  "reading.ReadingTimer.cancel": "Cancel",
  "reading.ReadingTimer.finishTitle": "Finish reading session",
  "reading.ReadingTimer.endingPage": "Ending page",
  "reading.ReadingTimer.endingElapsed": "Ending audiobook time (H:MM:SS)",
  "reading.ReadingTimer.invalidEndingElapsed":
    "Enter an audiobook time at or after the starting position.",
  "reading.ReadingTimer.elapsedBeyondEnd":
    "Audiobook time cannot exceed its total duration.",
  "reading.ReadingTimer.saveSession": "Save session",
  "reading.ReadingTimer.couldNotFinish": "The session could not be saved",
  "reading.ReadingTimer.invalidEndingPage":
    "Ending page cannot be before the page where this timer started.",
  "reading.ReadingTimer.pageBeyondEnd": "Ending page cannot be greater than {pages}.",
  "reading.ReadingTimer.discard": "Discard timer",
  "reading.ReadingTimer.cancelTitle": "Cancel reading timer?",
  "reading.ReadingTimer.cancelDescription":
    "This discards the elapsed time without logging a reading session.",
} as const;
